import { tutorialAssets } from "assets/cdn";
import { useImagePath } from "hooks/useImagePath";
import { FC, useEffect } from "react";
import { createPortal } from "react-dom";
import { useTutorialAnchor } from "../../../TutorialV2/hooks";
import { TutorialV2StepProps } from "../../types";
import {
	Arrow,
	ArrowDownContainer,
	Container,
	Content,
	NextButton,
	SkipButton,
	Slide,
	SlideNumber,
	Subtitle,
	Tiki,
	Title
} from "../styles";
import {
	LoyaltyBalanceGlobalStyles,
	LoyaltyBalanceShine,
	TutorialPanelScale
} from "./styles";

const LOYALTY_BALANCE_ID = "loyalty-point-balance";
const ARROW_CENTER_EM = 22.8;

export const Step1: FC<TutorialV2StepProps> = ({
	currentStep,
	totalSteps,
	onNext,
	onSkip
}) => {
	const { getImage } = useImagePath("cdn");
	const background = getImage(tutorialAssets.background);
	const ArrowImage = getImage(tutorialAssets.greenArrow);
	const ShineImage = getImage(tutorialAssets.shine);
	const TikiImage = getImage(tutorialAssets.char2);
	const { targetElement, targetRect } = useTutorialAnchor({
		targetId: LOYALTY_BALANCE_ID,
		shouldScroll: false
	});
	const appBarElement = targetElement?.closest<HTMLElement>(".MuiAppBar-root");
	const tutorialRoot = document.querySelector<HTMLElement>(
		"[data-tutorial-v2-root]"
	);
	const oneEm = tutorialRoot
		? parseFloat(window.getComputedStyle(tutorialRoot).fontSize)
		: 10;

	useEffect(() => {
		if (!targetElement || !appBarElement) {
			return;
		}

		appBarElement.classList.add("tutorial-loyalty-balance-appbar");
		targetElement.classList.add("tutorial-loyalty-balance-anchor");

		return () => {
			appBarElement.classList.remove("tutorial-loyalty-balance-appbar");
			targetElement.classList.remove("tutorial-loyalty-balance-anchor");
		};
	}, [appBarElement, targetElement]);

	return (
		<>
			<LoyaltyBalanceGlobalStyles />
			{appBarElement &&
				targetRect &&
				createPortal(
					<LoyaltyBalanceShine
						$left={targetRect.left + targetRect.width / 2}
						$top={targetRect.top + targetRect.height / 2}
						aria-hidden="true"
						src={ShineImage}
					/>,
					appBarElement
				)}
			{createPortal(
				<TutorialPanelScale $fontSize={oneEm}>
					<Container
						$anchorCenterOffset={targetRect ? targetRect.width / 2 : 0}
						$anchorLeft={targetRect?.left}
						$anchorOffset={5.5}
						$anchorTop={targetRect?.bottom}
						$arrowCenter={ARROW_CENTER_EM}
						$placement="below"
					>
						<ArrowDownContainer $right={8}>
							<Arrow src={ArrowImage} />
						</ArrowDownContainer>
						<SlideNumber>
							{currentStep}/{totalSteps}
						</SlideNumber>
						<Slide $backgroundImage={background}>
							<Tiki src={TikiImage} />
							<Content>
								<Title>
									Here&apos;s your Loyalty
									<br /> Points balance
								</Title>
								<Subtitle>
									You earn them with every web
									<br /> purchase.
								</Subtitle>
							</Content>
							<NextButton onClick={onNext}>Next</NextButton>
							<SkipButton onClick={onSkip}>Skip</SkipButton>
						</Slide>
					</Container>
				</TutorialPanelScale>,
				document.body
			)}
		</>
	);
};
